import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult,
  RowArgs, SelectionEvent
} from '@progress/kendo-angular-grid';

import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {BehaviorSubject, Observable, Subscription, of as observableOf} from 'rxjs';
import {ExportClientsService} from './export-clients.service';
import {ExportsNotesService} from './export-notes.service';
import * as moment from 'moment';
import {ClientsService} from '../../../../clients/clients.service';
import {SearchContext} from '../../../../services/search/search-context';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-exports',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'exports.template.html'
})
export class ExportsComponent implements OnInit, OnDestroy {

  public noteView: Observable<GridDataResult>;
  public clientView: Observable<GridDataResult>;
  //public subscription: Subscription;

  public selectedClients:string[] = [];
  public selectedNotes:string[] = [];

  public clientsState: State = {
    skip: 0,
    take: 10
  };
  public notesState: State = {
    skip: 0,
    take: 10
  };

  notesStart = moment().subtract(1, 'month').toDate();
  notesEnd = moment().toDate();
  clientsStart = moment().subtract(1, 'month').toDate();
  clientsEnd = moment().toDate();

  clientsRange = false;
  notesRange = false;

  public search: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private searchSubscription: Subscription;

  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private clientsService: ExportClientsService,
    private notesService: ExportsNotesService,
    private searchContext: SearchContext,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

    this.noteView = this.notesService;
    this.clientView = this.clientsService;
    this.allClientData = this.allClientData.bind(this);
    this.allNoteData = this.allNoteData.bind(this);
  }

  public ngOnInit(): void {

    this.searchSubscription = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
      if ((term || "").length >= 3 || (term || "").length === 0) {
        this.notesState.skip = 0;
        this.clientsState.skip = 0;
        this.search.next(term || "");
      }
    });
    this.search.subscribe(term => {
      this.getClients();
      this.getNotes();
    });
  }

  public ngOnDestroy(): void {
  }

  public notesStateChange(state: DataStateChangeEvent): void {
    this.notesState = state;
    this.getNotes();
  }

  public clientsStateChange(state: DataStateChangeEvent): void {
    this.clientsState = state;
    this.getClients();
  }

  public noteRangeChanged(event: Date) {
    this.getNotes();
  }

  public clientRangeChanged(event: Date) {
    this.getClients();
  }

  public getNotes() {
    const page = this.notesState.skip / this.notesState.take + 1;
    const limit = this.notesState.take;

    this.notesService.getNotes(this.notesRange ? this.notesStart.toISOString() : '', this.notesRange ? this.notesEnd.toISOString() : '', page, limit, () => {
      this.loading = false;
    }, this.search.value );
  }

  public allClientData(): Observable<any> {
    if( this.selectedClients && this.selectedClients.length) {
      let selectedClientArray = this.clientsService.value.data.filter( c => this.selectedClients.includes(c.id));
      return observableOf(<GridDataResult>{total:selectedClientArray.length, data:selectedClientArray});
    } else {
      return this.clientsService.getAllClients(this.clientsRange ? this.clientsStart.toISOString() : '', this.clientsRange ? this.clientsEnd.toISOString() : '', this.search.value);
    }
  }

  public allNoteData(): Observable<any> {
    if( this.selectedNotes && this.selectedNotes.length) {
      let selectedNoteArray = this.notesService.value.data.filter( n => this.selectedNotes.includes(n._id));
      return observableOf(<GridDataResult>{total:selectedNoteArray.length, data:selectedNoteArray});
    } else {
      return this.notesService.getAllNotes(this.notesRange ? this.notesStart.toISOString() : '', this.notesRange ? this.notesEnd.toISOString() : '', this.search.value);
    }
  }

  public getClients() {
    const page = this.clientsState.skip / this.clientsState.take + 1;
    const limit = this.clientsState.take;

    this.clientsService.getClients(this.clientsRange ? this.clientsStart.toISOString() : '', this.clientsRange ? this.clientsEnd.toISOString() : '', page, limit, () => {
      this.loading = false;
    }, this.search.value );
  }

}
